const resolveCheckedGroup = (values) => {
  const checkedCount = values.filter(Boolean).length;
  const someChecked = checkedCount > 0;
  const totalCount = values.length;
  if (someChecked && checkedCount !== totalCount) {
    return "mixed";
  }
  return someChecked;
};
export {
  resolveCheckedGroup
};
